import { APP_UPSELL_CAMPAIGN, type AppUpsellEntryPoint, isIPhone } from '@/config/app-upsells';
import type { AppUpsellProperties, AppUpsellSurface } from '@/events/app-upsells';
import { env } from '@/lib/config/env';
import { logger } from '@/lib/telemetry/logger';

let warnedMissingLink = false;

export function appUpsellProperties(
  surface: AppUpsellSurface,
  entryPoint: AppUpsellEntryPoint,
): AppUpsellProperties {
  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const darkTheme =
    typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  const tablet =
    /iPad/i.test(userAgent) ||
    (typeof navigator !== 'undefined' &&
      /Macintosh/i.test(userAgent) &&
      navigator.maxTouchPoints > 1);
  return {
    surface,
    entry_point: entryPoint,
    campaign: APP_UPSELL_CAMPAIGN,
    creative:
      surface === 'feed'
        ? darkTheme
          ? 'dark_card_feed'
          : 'light_card_feed'
        : surface === 'portfolio'
          ? darkTheme
            ? 'dark_card_portfolio'
            : 'light_card_portfolio'
          : surface === 'navigation'
            ? 'app_navigation'
            : 'pocket_dialog',
    device: isIPhone(userAgent)
      ? 'iphone'
      : /Android/i.test(userAgent)
        ? 'android'
        : tablet
          ? 'tablet'
          : 'desktop',
  };
}

export function warnMissingAttributionLink(): void {
  if (!env.NEXT_PUBLIC_APPSFLYER_ONELINK_URL && !warnedMissingLink) {
    warnedMissingLink = true;
    logger.warn('App upsells attribution link missing', { fallback: 'app_store' });
  }
}
